import * as React from 'react';
import RTKServiceForm from './form';

export default function RTKServiceCreate() {
  return (
    <RTKServiceForm />
  );
}